// Sends the buyer straight to Shopify checkout with the chosen pack. A cart permalink
// (/cart/<variant>:<qty>) replaces the cart so checkout shows only this order; with no
// product configured it opens WhatsApp instead. Without JS the form posts to /cart/add.
class CodOrder extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.form.addEventListener('change', () => this.syncHidden(), { signal });
    this.form.addEventListener('submit', (event) => this.handleSubmit(event), { signal });
    this.syncHidden();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  syncHidden() {
    const pack = this.form.querySelector('input[name="pack"]:checked');
    const id = this.form.querySelector('[data-cod-id]');
    const quantity = this.form.querySelector('[data-cod-quantity]');
    if (!pack) return;
    if (id && pack.dataset.variant) id.value = pack.dataset.variant;
    if (id) id.dataset.label = pack.dataset.label || '';
    if (quantity) quantity.value = pack.dataset.quantity || '1';
  }

  handleSubmit(event) {
    this.syncHidden();
    const idInput = this.form.querySelector('[data-cod-id]');
    const variant = idInput?.value;
    const quantity = this.form.querySelector('[data-cod-quantity]')?.value || '1';
    event.preventDefault();
    if (variant) {
      window.location.href = `${this.dataset.cartUrl}/${variant}:${quantity}`;
      return;
    }
    const text = [this.dataset.whatsappIntro, idInput?.dataset.label || ''].filter(Boolean).join('\n');
    window.location.href = `https://wa.me/${this.dataset.whatsapp || ''}?text=${encodeURIComponent(text)}`;
  }
}

if (!customElements.get('s-cod-order')) customElements.define('s-cod-order', CodOrder);
